// Making a new JS component
// 1 - Replace filteredList with new name ( 8 occurences in this file )
// 2 - All code goes into init()
// 3 - Save file as new name .js
var filteredListV2 = {
	name: 'filteredListV2',
	componentInitSelector: '.filtered-list--v2',
	registerComponent: function () {
		if ($(filteredListV2.componentInitSelector).length) {
			framework.registerComponent(filteredListV2);
		}
	},
	initfilteredList: function () {
		// Put your args and inits here with their options.

		// End
		log(config.application.name + " •• filteredList in " + Math.round(performance.now() - framework.initComponents.componentInitTime) + " milliseconds");
	},
	init: function () {
		// All code for this component goes in here
		var initShow = 21; //number of items loaded on init & onclick load more button
		var counter = initShow;
		var qsRegex;
		var filters = [];

		// set initial filters
		$('.filtered-list--v2 .filters .filter').each(function() {
			updateFilters($(this));
		});

		// init Isotope
		var $grid = $('.grid').isotope({
			itemSelector: '.filteredItem',
			filter: function () {
				if (!qsRegex && (Object.keys(filters).length == 0)) {
					return true;
				}

				var elemText = $(this).text();

				var valid = false;
				if (qsRegex) {
					valid = qsRegex.test(elemText);
					if (!valid) {
						return false;
					}
				}

				if (Object.keys(filters).length == 0) {
					return true;
				}

				valid = true;
				var $elem = $(this);

				for (var name in filters) {
					var filterValues = filters[name];
					if (filterValues == null || filterValues.length == 0) {
						continue;
					}

					var elemFilterValue = $elem.data('filter-' + name);
					if (!elemFilterValue) {
						continue;
					}

					var filterValid = false;
					$.each(filterValues, function (index, filterValue) {
						if (elemFilterValue.indexOf(filterValue) > -1) {
							filterValid = true;
							return false;
						}
					});

					if (!filterValid) {
						valid = false;
						break;
					}
				}

				return valid;
			}
		});

		var $quicksearch = $('.quicksearch').keyup(debounce(function () {
			var value = $quicksearch.val();
			if (value) {
				qsRegex = new RegExp(value, 'im');
			} else {
				qsRegex = null;
			}

			$quicksearch.keypress(function (e) {
				if (e.which == 13) {
					$(window).scrollTo('#post-content', { duration: 800 });
					document.activeElement.blur();
					$("input").blur();
				}
			});

			$grid.find(".hidden").removeClass("hidden");
			$grid.isotope();
			loadMore(initShow);
		}, 200));


		function debounce(fn, threshold) {
			var timeout;
			threshold = threshold || 100;
			return function debounced() {
				clearTimeout(timeout);
				var args = arguments;
				var _this = this;
				function delayed() {
					fn.apply(_this, args);
				}
				timeout = setTimeout(delayed, threshold);
			};
		}

		var iso = $grid.data('isotope');
		var $displayCountElem = $('.filtered-list__display-count');

		function loadMore(toShow) {
			$grid.find(".hidden").removeClass("hidden");

			var hiddenElems = iso.filteredItems.slice(toShow, iso.filteredItems.length).map(function (item) {
				return item.element;
			});

			var hiddenCount = $(hiddenElems).addClass('hidden').length;

			//when no more to load, hide show more button
			if (hiddenElems.length == 0) {
				$(".load-more").hide();
			} else {
				$(".load-more").show();
			};

			var showing = iso.filteredItems.length - hiddenCount;

			$displayCountElem.text('Showing ' + showing + ' of ' + iso.filteredItems.length);


			$grid.isotope('layout');
		}
		
		loadMore(initShow);

		//when load more button clicked
		$(".load-more").click(function () {
			if (filters.length > 0) {
				//when filter button clicked, set initial value for counter
				counter = initShow;
				$('#filters').data('clicked', false);
			} else {
				counter = counter;
			};

			counter = counter + initShow;

			loadMore(counter);
		});


		// store filter for each group
		$('.filtered-list--v2 .filters .filter').change(function (event) {
			updateFilters($(this));
			// filter isotope
			$grid.find(".hidden").removeClass("hidden");
			$grid.isotope();
			loadMore(initShow);
		});

		function updateFilters(select) {
			var filterName = select.data('filter-name') || select.attr('name');
			var filterValues = select.val();
			if (filterValues == null || filterValues.length == 0) {
				delete filters[filterName];
				return;
			}

			filters[filterName] = select.val();
		}

		// reset button
		$('.filtered-list').on('click', '.tabButton', function (event) {
			event.preventDefault();

			$('.quicksearch').val('');
			qsRegex = null;

			var filterElems = $('.filtered-list--v2 .filters .filter');
			filterElems.val('');
			filterElems.selectpicker('refresh');

			filters = [];

			$grid.fadeOut(50, 'swing', function() {
				$grid.fadeIn(50, 'swing', function() {
					$grid.find(".hidden").removeClass("hidden");
					$grid.isotope();
					loadMore(initShow);
				});
			});
		})

		// End
		filteredListV2.initfilteredList();

	}
}

// Register self to the framework
filteredListV2.registerComponent();